import { useTranslation } from "react-i18next";
import { TWclassNames } from "../../utils/Div";
import { status } from "../../Utils";

/** Mirrors `WorkOrder::STATUS_INCLUSION` in the API */
export const WORK_ORDER_STATUS_INCLUSION = [
  "draft",
  "ongoing",
  "finished",
  "processing",
  "processed",
  "cancelled",
  "ready_invoice",
  "invoiced",
  "rejected",
  "approved",
  "updated",
];
import {
  CheckBadgeIcon,
  ExclamationCircleIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";

export const workOrderParticipantsRole = [
  {
    id: "RESPONSIBLE",
    name: "RESPONSIBLE",
    value: "RESPONSIBLE",
    label: "Responsible",
    title: "Responsible",
  },
  {
    id: "RESPONSIBLE_EXECUTOR",
    name: "RESPONSIBLE_EXECUTOR",
    value: "RESPONSIBLE_EXECUTOR",
    label: "Responsible Executor",
    title: "Responsible Executor",
  },
  {
    id: "EXECUTOR",
    name: "EXECUTOR",
    value: "EXECUTOR",
    label: "Executor",
    title: "Executor",
  },
  {
    id: "OBSERVER",
    name: "OBSERVER",
    value: "OBSERVER",
    label: "Observer",
    title: "Observer",
  },
];

export const workOrderParticipantsStatus = [
  {
    value: "ASSIGNED",
    label: "Assigned",
    title: "Assigned",
  },
  {
    value: "ACCEPTED",
    label: "Accepted",
    title: "Accepted",
  },
  {
    value: "COMPLETED",
    label: "Completed",
    title: "Completed",
  },
];

export const WorkOrderParticipantStatus = ({ participant }) => {
  const { t } = useTranslation();

  return (
    <span
      className={TWclassNames(
        participant?.status && !participant?.is_invoiced
          ? status[participant?.status]?.class
          : "",
        "inline-flex rounded-full px-2 text-xs font-semibold leading-5"
      )}
    >
      {participant?.is_invoiced ? (
        <span>Fakturert</span>
      ) : (
        <>
          {participant.status ? (
            <span>
              {" "}
              {t(status[participant?.status]?.label || participant?.status)}
            </span>
          ) : (
            <span className="bg-gray-100 inline-flex rounded-full px-2 text-xs font-semibold leading-5">
              {t("None")}
            </span>
          )}
        </>
      )}
    </span>
  );
};

export function WorkOrderOperationStatus({ operations, operationName, title }) {
  const filteredOperations =
    operations?.filter(
      (operation) => operation?.message === operationName
    ) ?? [];
  const rows = filteredOperations;

  const optionalOk =
    rows.length > 0 &&
    rows.every((operation) => operation?.can_be_completed === true);
  const blocking = rows.length > 0 && !optionalOk;

  let shellClass =
    "rounded-lg border p-4 shadow-sm flex gap-3 items-start transition-colors";
  let iconWrapClass =
    "flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full ";
  let Icon = CheckBadgeIcon;
  let iconClass = "h-5 w-5 text-emerald-600";

  if (blocking) {
    shellClass += " border-red-200 bg-red-50/60";
    iconWrapClass += " bg-red-100";
    Icon = ExclamationCircleIcon;
    iconClass = "h-5 w-5 text-red-600";
  } else if (optionalOk) {
    shellClass += " border-amber-200 bg-amber-50/50";
    iconWrapClass += " bg-amber-100";
    Icon = QuestionMarkCircleIcon;
    iconClass = "h-5 w-5 text-amber-700";
  } else {
    shellClass += " border-emerald-200 bg-emerald-50/40";
    iconWrapClass += " bg-emerald-100";
  }

  function description() {
    if (rows.length === 0) return "Alt ser bra ut!";

    if (optionalOk) return "Arbeidsordren kan ferdigstilles uten";

    return "Arbeidsordren kan ikke ferdigstilles uten";
  }

  return (
    <div className={TWclassNames(shellClass)}>
      <div className={iconWrapClass}>
        <Icon className={iconClass} aria-hidden />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-gray-900">{title}</p>
        <p className="mt-1 text-xs text-gray-600">{description()}</p>
      </div>
    </div>
  );
}

export function OperationCanFinish({ operations, operationName }) {
  // filter operations by operation name
  const filteredOperations = operations?.filter(
    (operation) => operation?.name === operationName
  );

  // Check if any filteredOperations has can_be_completed set to false
  const canBeCompleted = filteredOperations?.every(
    (operation) => operation?.can_be_completed === true
  );

  // return false if any operation has can_be_completed set to false
  return canBeCompleted;
}
